import React from "react"

import CourseCategory from "./courseCategory"
// categories displayed on main LEO Academy page

import styles from "./coursesCategories.module.scss"

const CoursesCategories = ({ categories, displayGenius, genius }) => (
  <div className={styles.categories}>
    {displayGenius && <CourseCategory cat={genius} slug="genius" />}

    {categories.map(cat => (
      <CourseCategory cat={cat} />
    ))}
  </div>
)

export default CoursesCategories
